import { render, staticRenderFns } from "./PopupBox.vue?vue&type=template&id=ef63b80a&scoped=true&"
import script from "./PopupBox.vue?vue&type=script&lang=js&"
export * from "./PopupBox.vue?vue&type=script&lang=js&"
import style0 from "./PopupBox.vue?vue&type=style&index=0&id=ef63b80a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ef63b80a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('ef63b80a')) {
      api.createRecord('ef63b80a', component.options)
    } else {
      api.reload('ef63b80a', component.options)
    }
    module.hot.accept("./PopupBox.vue?vue&type=template&id=ef63b80a&scoped=true&", function () {
      api.rerender('ef63b80a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-2PdljHn5WMR91/JS/comp/PopupBox.vue"
export default component.exports